import React from "react";
import "./App.css";
import "./app/components/platform/platform.css";
import { BrowserRouter } from "react-router-dom";
import TopBar from "../src/app/components/TopBar";
import { BottomBar } from "./app/components";
import FullPageLayout from "./app/components/FullPageLayout";
import { ThemeModeProvider } from "./app/components/theme";
import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeModeProvider>
          <TopBar />
          <FullPageLayout />
          <BottomBar />
        </ThemeModeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
